let _id = 0;
let _list = new Map();

const FJAudioPlayManager = {
    list: [],
    createId: () => {
        ++_id;
        return _id;
    },
    delete: id => {
        if (_list.has(id)) {
            try {
                const audio = _list.get(id);
                audio?.pause && audio.pause(); // 删除前先暂停播放
                _list.delete(id);
            } catch (e) {
                console.log(e);
            }
        }
    },
    add: (id, options) => {
        if (!_list.has(id)) {
            _list.set(id, options);
        }

        try {
            _list.forEach((value, key) => {
                if (key !== id) {
                    value?.pause && value.pause();
                }
            });
        } catch (e) {
            console.log(e);
        }
    },
    pauseAll: () => {
        _list.forEach(value => {
            try {
                value?.pause && value.pause();
            } catch (e) {
                console.log(e);
            }
        });
    },
};

export default FJAudioPlayManager;
